import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Divisions from './components/Divisions';
import Services from './components/Services';
import Testimonial from './components/Testimonial';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/fd65981c-4279-4dc5-8881-1f18e49dc964.png"
              alt="InovaBioCorp Logo"
              className="h-12 w-auto"
            />
            <span className={`text-xl font-bold ${scrolled ? 'text-[#002B5C]' : 'text-white'}`}>
              InovaBioCorp
            </span>
          </div>
          <div className="flex items-center gap-8">
            <a
              href="#home"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-[#002B5C] hover:text-[#FFC107]' : 'text-white hover:text-[#FFC107]'
              }`}
            >
              Home
            </a>
            <a
              href="#medical-devices"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-[#002B5C] hover:text-[#FFC107]' : 'text-white hover:text-[#FFC107]'
              }`}
            >
              Medical Devices
            </a>
            <a
              href="#pharmaceuticals"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-[#002B5C] hover:text-[#FFC107]' : 'text-white hover:text-[#FFC107]'
              }`}
            >
              Pharmaceuticals
            </a>
            <a
              href="#research-labs"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-[#002B5C] hover:text-[#FFC107]' : 'text-white hover:text-[#FFC107]'
              }`}
            >
              Research Labs
            </a>
            <a
              href="#about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-[#002B5C] hover:text-[#FFC107]' : 'text-white hover:text-[#FFC107]'
              }`}
            >
              About Us
            </a>
            <a
              href="#contact"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-[#002B5C] hover:text-[#FFC107]' : 'text-white hover:text-[#FFC107]'
              }`}
            >
              Contact
            </a>
          </div>
        </div>
      </nav>

      <Hero />
      <About />
      <Divisions />
      <Services />
      <Testimonial />
      <CTA />
      <Footer />
    </div>
  );
}